export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--4-0!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bg-image.vue?vue&type=template&id=2b066fda"


//////////////////
// WEBPACK FOOTER
// ./src/js/components/bg-image/bg-image.vue?vue&type=template&id=2b066fda
// module id = ./src/js/components/bg-image/bg-image.vue?vue&type=template&id=2b066fda
// module chunks = 4 5